module.exports = __webpack_public_path__ + "media/enter_keypair_name.cb8b9a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cloud/server/enter_keypair_name.png
// module id = 743
// module chunks = 2